import { t } from '@glory/i18n';
import { EmptyState } from '@glory/ui';
import { createFileRoute } from '@tanstack/react-router';
import { MessagesSquare } from 'lucide-react';

export const Route = createFileRoute('/_app/messages/')({
  component: NoChat,
});

/** Компьютер: чат не выбран. На телефоне на этом адресе виден список. */
function NoChat() {
  return (
    <div className="flex flex-1 items-center justify-center">
      <EmptyState
        icon={<MessagesSquare />}
        title={t('messenger.pickTitle')}
        description={t('messenger.pickText')}
        className="items-center text-center"
      />
    </div>
  );
}
